import { ChangeDetectionStrategy, Component, inject, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  LOANDEPOT_SUPPORT_DISPLAY,
  LOANDEPOT_SUPPORT_TEL,
  SUPPORT_EMAIL,
  SUPPORT_EMAIL_MAILTO,
} from '@ld.consumer-portal/constants';
import { PlatformService } from '@ld.consumer-portal/utils';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-terms-of-use-modal',
  imports: [BaseModalComponent, MatIconModule, TranslocoDirective],
  templateUrl: './terms-of-use-modal.component.html',
  styleUrl: './terms-of-use-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsOfUseModalComponent {
  private readonly platformService = inject(PlatformService);

  protected readonly isNativeMobile = this.platformService.isNativeMobile;

  protected readonly isVisible = signal(true);

  readonly close = output<void>();

  protected readonly supportPhone = LOANDEPOT_SUPPORT_DISPLAY;
  protected readonly supportPhoneTel = LOANDEPOT_SUPPORT_TEL;

  protected readonly supportEmail = SUPPORT_EMAIL;
  protected readonly supportEmailMailto = SUPPORT_EMAIL_MAILTO;

  protected onClose(): void {
    this.closeModal();
  }

  protected onBackdropClick(): void {
    this.closeModal();
  }

  protected onDone(): void {
    this.closeModal();
  }

  private closeModal(): void {
    this.isVisible.set(false);
    setTimeout(() => {
      this.close.emit();
    }, 200);
  }
}
